var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-center" }, [
    _c("div", { staticClass: "account-icon me-3" }, [
      _vm.teacher.image
        ? _c("img", {
            staticClass: "img-fluid",
            staticStyle: { "clip-path": "circle()", width: "100%" },
            attrs: { src: _vm.teacher.image.url },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ps-3" }, [
      _c("div", { staticClass: "small" }, [
        _vm._v(_vm._s(_vm.teacher.name) + "先生"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "small" }, [_vm._v(_vm._s(_vm.teacher.catch))]),
      _vm._v(" "),
      _c("div", { staticClass: "small" }, [
        _c("strong", [
          _vm._v("わかりやすい " + _vm._s(_vm.teacher.pointCount) + "pt"),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }